import * as React from "react";
import * as AuthStore from "../store/Auth";
import * as moment from 'moment';
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { fetchData, postQuery } from '../utils';
import { Button, Select, Card, message, DatePicker, Row, Col, Tabs, Divider } from 'antd';
import {
    ReloadOutlined, BarsOutlined, ExceptionOutlined, EyeInvisibleOutlined, CalculatorOutlined,
    ReconciliationOutlined, TagsOutlined, MedicineBoxOutlined, DownloadOutlined,
    SolutionOutlined, ExperimentOutlined, UngroupOutlined, CarryOutOutlined, CodeOutlined,
    ScheduleOutlined, ProjectOutlined, FileSyncOutlined, TagOutlined, SwitcherOutlined, FileUnknownOutlined, CalendarOutlined,
    AuditOutlined, BankOutlined, ContainerOutlined, PhoneOutlined, PullRequestOutlined, ContactsOutlined
} from '@ant-design/icons/lib';
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Edqa extends React.Component<AuthProps>
{
    public state =
    {
            data: [],
            lineList: [],
            stateList: [],
            siteList: [],
            clientSite: false,
            statesLoaded: true,
            siteId: 0,
            loading: false,
            confirmLoading: false,
            site: { id: 0, name: '', stateName: '', stateCode: '', stateId: '' },
            state: { stateId: 0, stateName: '', stateCode: '', sites: [] },   
            states: [],
            sites: [],
            searchObj:
            {
                from: '',
                to: '',
                stateId: 0,
                state: '',
                site: 0,
                siteId: '',
                siteName: '',
                stateName: ''
             },
            tHeads: [],
            tBody: [],
            showingInfoWindow: false,
            selectedPlace: { name: '' },
            edqa:
            {
                labDqa:
                {
                    withoutResult: 0,
                    noSampleType: 0,
                    noIndication: 0,
                    noSampleCollectionDate: 0,
                    noDateOrdered: 0
                },
                artCommencementDqa:
                {
                    noClinicalStageAtStartOfART: 0,
                    noWeight: 0,
                    noHeight: 0,
                    noWhoStage: 0,
                    noArtStartDate: 0,
                    noFirstArvRegimen: 0,
                    noFirstRegimenLine: 0,
                    noFunctionalStatus: 0,
                    noMuac: 0
                },
                pbsDqa: { noPbs: 0},
                pharmacyDqa:
                {
                    zeroDuration: 0,
                    below30Duration: 0,
                    zeroDosage: 0,
                    noTreatmentAgeCategory: 0,
                    noCurrentRegimenLine: 0,
                    noARVRegimen: 0,
                    noFrequency: 0,
                    noARVQtyPrescribed: 0,
                    noARVQtyDispensed: 0,
                    noTreatmentType: 0,
                    noVisitType: 0,
                    noPickUpReason: 0,
                    noModelOfCare: 0,
                    noARVStrenght: 0,
                    durationAbove180: 0,
                },
                patientDqa:
                {
                    noDateOfBirth: 0,
                    noSex: 0,
                    noPhoneNumber: 0,
                    noHospitalNumber: 0,
                    noAddress: 0,
                    noStateOfResidence: 0,
                    noLGA: 0,
                    inconsistentArtStartDate: 0
                },
                hivEnrollmentDqa:
                {
                    noDateEnrolledInCare: 0,
                    noDateConfirmedHIVPositive: 0,
                    noModeOfHIVTest: 0,
                    noCareEntryPoint: 0,
                    noArtStartDate: 0,
                    noFacilityTransferredInFrom: 0,
                    noDateTransferredIn: 0,
                },
                carecardDqa:
                {
                    noSystolic: 0,
                    noDiastolic: 0,
                    noWeight: 0,
                    noHeight: 0,
                    noWhoStage: 0,
                    noNextAppointmentDate: 0,
                    noFunctionalStatus: 0,
                }
            },
            activeTab: 1,
            phEdqaLink: { asset: '', url: '', fileName: '' },
            artEdqaLink: { asset: '', url: '', fileName: '' },
            hivEnrlmtEdqaLink: { asset: '', url: '', fileName: '' },
            ccardEdqaLink: { asset: '', url: '', fileName: '' },
            patientEdqaLink: { asset: '', url: '', fileName: '' },
            labEdqaLink: { asset: '', url: '', fileName: '' },
            pbsDqaEdqaLink: { asset: '', url: '', fileName: '' },
            fileUrl: '',
    };
    async componentDidMount()
    {    
        let el = this;

        let user = el.props.appUser;     
        let sts = localStorage.getItem("states");
        let states = [];    
        if (sts) states = JSON.parse(sts);

        let sites = [];
        if (user.stateCode && user.stateCode.length > 0)
        {
            var statex = states.filter(s =>
            {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0)
            {
                let { searchObj } = this.state;
                let state: any = states[0];
                searchObj.stateName = state.stateName;
                searchObj.stateId = state.stateId;
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, sites, statesLoaded });
    }
    selectSite(value: any)
    {
        const { searchObj } = this.state;
        if (value)
        {
            searchObj.site = value.key;
            searchObj.siteId = value.key;
            let sites: any = this.state.state.sites.filter(function (o: any) { return o.id === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj });  
        } 
    }
    selectState(value: any)
    {
        if (!value)
        {
            return;
        }

        const { searchObj } = this.state;          
        searchObj.site = 0;
        if (value)
        {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0)
            {
                var state = states[0];
                //state.sites = states[0].sites;
                searchObj.stateName = state.stateName;
                searchObj.stateId = state.stateId;
                searchObj.state = state.stateCode;
                this.setState({ state: state, searchObj: searchObj });
            } 
        }        
    }
    reset()
    {           
        this.setState({
            searchObj:
            {
                from: '',
                to: '',
                stateId: 0,
                state: '',
                site: 0,
                siteId: 0,
                siteName: '',
                stateName: ''
            },
            edqa:
            {
                labDqa:
                {
                    withoutResult: 0,
                    noSampleType: 0,
                    noIndication: 0,
                    noSampleCollectionDate: 0,
                    noDateOrdered: 0
                },
                artCommencementDqa:
                {
                    noClinicalStageAtStartOfART: 0,
                    noWeight: 0,
                    noHeight: 0,
                    noWhoStage: 0,
                    noArtStartDate: 0,
                    noFirstArvRegimen: 0,
                    noFirstRegimenLine: 0,
                    noFunctionalStatus: 0,
                    noMuac: 0
                },
                pbsDqa: { noPbs: 0 },
                pharmacyDqa:
                {
                    zeroDuration: 0,
                    below30Duration: 0,
                    zeroDosage: 0,
                    noTreatmentAgeCategory: 0,
                    noCurrentRegimenLine: 0,
                    noARVRegimen: 0,
                    noFrequency: 0,
                    noARVQtyPrescribed: 0,
                    noARVQtyDispensed: 0,
                    noTreatmentType: 0,
                    noVisitType: 0,
                    noPickUpReason: 0,
                    noModelOfCare: 0,
                    noARVStrenght: 0,
                    durationAbove180: 0,
                },
                patientDqa:
                {
                    noDateOfBirth: 0,
                    noSex: 0,
                    noPhoneNumber: 0,
                    noHospitalNumber: 0,
                    noAddress: 0,
                    noStateOfResidence: 0,
                    noLGA: 0,
                    inconsistentArtStartDate: 0
                },
                hivEnrollmentDqa:
                {
                    noDateEnrolledInCare: 0,
                    noDateConfirmedHIVPositive: 0,
                    noModeOfHIVTest: 0,
                    noCareEntryPoint: 0,
                    noArtStartDate: 0,
                    noFacilityTransferredInFrom: 0,
                    noDateTransferredIn: 0,
                },
                carecardDqa:
                {
                    noSystolic: 0,
                    noDiastolic: 0,
                    noWeight: 0,
                    noHeight: 0,
                    noWhoStage: 0,
                    noNextAppointmentDate: 0,
                    noFunctionalStatus: 0,
                }
            },
            phEdqaLink: { asset: '', url: '', fileName: '' },
            artEdqaLink: { asset: '', url: '', fileName: '' },
            hivEnrlmtEdqaLink: { asset: '', url: '', fileName: '' },
            ccardEdqaLink: { asset: '', url: '', fileName: '' },
            patientEdqaLink: { asset: '', url: '', fileName: '' },
            labEdqaLink: { asset: '', url: '', fileName: '' },
            pbsDqaEdqaLink: { asset: '', url: '', fileName: '' },
            fileUrl: '',
        });
    }
    dateRangeChange(a: any[], dateString: any) {
        let from = '';
        let to = '';
        if (dateString && dateString[0]) {
            from = dateString[0];
        }
        else {
            from = '';
        }

        if (dateString && dateString[1]) {
            to = dateString[1];
        }
        else {
            from = '';
        }
        const { searchObj } = this.state;
        searchObj.from = from;
        searchObj.to = to;
        this.setState({ searchObj });
    }
    shallowReset()
    {
        this.setState({
            edqa:
            {
                labDqa:
                {
                    withoutResult: 0,
                    noSampleType: 0,
                    noIndication: 0,
                    viralLoadRes: 0,
                    noSampleCollectionDate: 0,
                    noDateOrdered: 0
                },
                artCommencementDqa:
                {
                    noClinicalStageAtStartOfART: 0,
                    noWeight: 0,
                    noHeight: 0,
                    noWhoStage: 0,
                    noArtStartDate: 0,
                    noFirstArvRegimen: 0,
                    noFirstRegimenLine: 0,
                    noFunctionalStatus: 0,
                    noMuac: 0
                },
                pbsDqa: { noPbs: 0 },
                pharmacyDqa:
                {
                    zeroDuration: 0,
                    below30Duration: 0,
                    zeroDosage: 0,
                    noTreatmentAgeCategory: 0,
                    noCurrentRegimenLine: 0,
                    noARVRegimen: 0,
                    noFrequency: 0,
                    noARVQtyPrescribed: 0,
                    noARVQtyDispensed: 0,
                    noTreatmentType: 0,
                    noVisitType: 0,
                    noPickUpReason: 0,
                    noModelOfCare: 0,
                    noARVStrenght: 0,
                    durationAbove180: 0,
                },
                patientDqa:
                {
                    noDateOfBirth: 0,
                    noSex: 0,
                    noPhoneNumber: 0,
                    noHospitalNumber: 0,
                    noAddress: 0,
                    noStateOfResidence: 0,
                    noLGA: 0,
                    inconsistentArtStartDate: 0
                },
                hivEnrollmentDqa:
                {
                    noDateEnrolledInCare: 0,
                    noDateConfirmedHIVPositive: 0,
                    noModeOfHIVTest: 0,
                    noCareEntryPoint: 0,
                    noArtStartDate: 0,
                    noFacilityTransferredInFrom: 0,
                    noDateTransferredIn: 0,
                },
                carecardDqa:
                {
                    noSystolic: 0,
                    noDiastolic: 0,
                    noWeight: 0,
                    noHeight: 0,
                    noWhoStage: 0,
                    noNextAppointmentDate: 0,
                    noFunctionalStatus: 0,
                }
            },
            phEdqaLink: { asset: '', url: '', fileName: '' },
            artEdqaLink: { asset: '', url: '', fileName: '' },
            hivEnrlmtEdqaLink: { asset: '', url: '', fileName: '' },
            ccardEdqaLink: { asset: '', url: '', fileName: '' },
            patientEdqaLink: { asset: '', url: '', fileName: '' },
            labEdqaLink: { asset: '', url: '', fileName: '' },
            pbsDqaEdqaLink: { asset: '', url: '', fileName: '' },
            fileUrl: '',
        }); 
    }
    async qQ()
    {
        let el = this;
        const { searchObj } = el.state;

        if (searchObj.siteId === null || searchObj.siteId === undefined || searchObj.siteId.length < 1 || searchObj.siteId === '0')
        {
            message.error("Please select a Facility");
            return;
        }
        if (searchObj.from === null || searchObj.from === undefined || searchObj.from.length < 1 || searchObj.to === null || searchObj.to === undefined || searchObj.to.length < 1)
        {
            message.error("Please select a Date Range");
            return;
        }        

        this.shallowReset();

        var site = searchObj.siteId ? searchObj.siteId : 0;

        el.setState({ loading: true });

        let res = await fetchData('/api/Stats/edqa?siteId=' + site + '&from=' + searchObj.from + '&to=' + searchObj.to);        
        el.setState({ edqa: res, loading: false  });

        var edUrl = '/api/Stats/fetchEdqaData?siteId=' + site + '&siteName=' + searchObj.siteName + '&from=' + searchObj.from + '&to=' + searchObj.to + '&pointer=';

        let resx = await fetchData(edUrl + 'patient');
        if (resx.code > 0)
        {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + resx.asset + '&filename=' + resx.fileName;
            this.setState({ patientEdqaLink: { asset: resx.asset, url: fUrl, fileName: resx.fileName } });
        }
        resx = await fetchData(edUrl + 'pharmacy');
        if (resx.code > 0)
        {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + resx.asset + '&filename=' + resx.fileName;
            this.setState({ phEdqaLink: { asset: resx.asset, url: fUrl, fileName: resx.fileName } });  
        }  
        resx = await fetchData(edUrl + 'artcommencement');
        if (resx.code > 0)
        {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + resx.asset + '&filename=' + resx.fileName;
            this.setState({ artEdqaLink: { asset: resx.asset, url: fUrl, fileName: resx.fileName } });
        }
        resx = await fetchData(edUrl + 'hivenrolment');
        if (resx.code > 0) {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + resx.asset + '&filename=' + resx.fileName;
            this.setState({ hivEnrlmtEdqaLink: { asset: resx.asset, url: fUrl, fileName: resx.fileName } });
        }
        resx = await fetchData(edUrl + 'carecard');
        if (resx.code > 0) {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + resx.asset + '&filename=' + resx.fileName;
            this.setState({ ccardEdqaLink: { asset: resx.asset, url: fUrl, fileName: resx.fileName } });
        }
        resx = await fetchData(edUrl + 'lab');
        if (resx.code > 0) {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + resx.asset + '&filename=' + resx.fileName;
            this.setState({ labEdqaLink: { asset: resx.asset, url: fUrl, fileName: resx.fileName} });
        }
        resx = await fetchData(edUrl + 'pbs');
        if (resx.code > 0)
        {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + resx.asset + '&filename=' + resx.fileName;
            this.setState({ pbsDqaEdqaLink: { asset: resx.asset, url: fUrl, fileName: resx.fileName } });
        }
    }
    setTab(e)
    {
        this.setState({ activeTab: e });
    }
    downloadFile(url)
    {
        this.setState({ loading: false, fileUrl: url });  
    }
    async mergeDataFiles()
    {
        let el = this;
        var paths =
            [
                el.state.patientEdqaLink, el.state.phEdqaLink, el.state.artEdqaLink, el.state.hivEnrlmtEdqaLink, el.state.ccardEdqaLink, el.state.labEdqaLink, el.state.pbsDqaEdqaLink
            ];
        el.setState({ loading: true });
        var res = await postQuery('/api/Stats/mergeFiles?site=' + el.state.searchObj.siteName, JSON.stringify(paths));
        el.setState({ loading: false });
        if (res.code > 0)
        {
            let fUrl = '/api/Stats/getEdqaFile?baseF=' + res.asset + '&filename=' + res.fileName;;
            el.setState({ loading: false, fileUrl: fUrl });
        }
        else
        {
            message.error(res.message);
        }
    }
    render() 
    {
        const { state, loading, states, searchObj, edqa, fileUrl, phEdqaLink, artEdqaLink, hivEnrlmtEdqaLink, ccardEdqaLink, patientEdqaLink, labEdqaLink, pbsDqaEdqaLink} = this.state;
        let user = this.props.appUser;
        let el = this;
        let labDqa = edqa.labDqa;
        let artCommencementDqa = edqa.artCommencementDqa;
        let pbsDqa = edqa.pbsDqa;
        let pharmacyDqa = edqa.pharmacyDqa;
        let patientDqa = edqa.patientDqa;
        let hivEnrollmentDqa = edqa.hivEnrollmentDqa;
        let carecardDqa = edqa.carecardDqa;
                
        return (
            <div style={{marginTop: '15px', padding: '20px'}}>
                <Helmet>
                    <title>CDR :: E-DQA</title>
                </Helmet>    
                <div className="custom-filter-dropdown">      
                    <Row style={{ marginTop: '2px' }}>
                        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>E-DQA (Data Quality/Completeness Checks)</h4>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            {(labEdqaLink.url.length > 0 || phEdqaLink.url.length > 0 || artEdqaLink.url.length > 0 || hivEnrlmtEdqaLink.url.length > 0 || ccardEdqaLink.url.length > 0 || patientEdqaLink.url.length > 0 || pbsDqaEdqaLink.url.length > 0)&& <Button className="ant-btn ant-btn-primary2 ant-btn-lg" style={{ float: 'right' }} onClick={() => this.mergeDataFiles()} icon={<DownloadOutlined />} size="large" title="Download underlying data" disabled={loading}>
                                Download all data
                             </Button>}
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="ant-modal-footer si-ant card-container" style={{ paddingTop: '10px' }}>  
                            <Card className="ant-card-body pfs s-list">
                                <Row>
                                    <Col span={24}>                                       
                                        {!user.stateCode && < Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <Select className="circl-radius"
                                                    labelInValue
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    //@ts-ignore
                                                    value={{ key: searchObj.stateId }}
                                                    style={{ width: '100%' }}
                                                    placeholder="Select State"
                                                    onChange={(value) => this.selectState(value)}
                                                >
                                                    <Option key={0} value={0}>-- Select State --</Option>
                                                    {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                                </Select>
                                            </Col>
                                        </Row>}
                                        < Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <Select className="circl-radius"
                                                    labelInValue
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    style={{ width: '99%', float: 'right' }}
                                                    //@ts-ignore
                                                    value={{ key: searchObj.site }}
                                                    placeholder="Select Site"
                                                    onChange={(value) => this.selectSite(value)}
                                                >
                                                    <Option key={0} value={0}>-- Select Site --</Option>
                                                    {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                                </Select>
                                            </Col>
                                        </Row>   
                                        < Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <RangePicker className="circl-radius"
                                                    //@ts-ignore
                                                    value={[searchObj.from.length > 0 ? moment(searchObj.from, "YYYY-MM-DD") : null, searchObj.to.length > 0 ? moment(searchObj.to, "YYYY-MM-DD") : null]}
                                                    allowClear={true} onChange={(a: any, b: any) => this.dateRangeChange(a, b)} disabled={loading}
                                                />
                                            </Col>
                                        </Row> 
                                        <Row style={{ marginBottom: '8px' }} gutter={2}>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <Button type="default" disabled={loading} className="login-button reset mer-fetch" size="large" onClick={() => this.reset()}>
                                                    <ReloadOutlined /> Reset
                                            </Button>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <Button disabled={loading} className="login-button mer-fetch" loading={loading} type="primary" size="large" onClick={() => this.qQ()}>
                                                    {loading ? 'loading...' : 'Fetch Data'}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>                       
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={18} xl={18} className="ant-modal-footer si-ant card-container" style={{ paddingTop: '10px' }}>
                            <Card className="ant-card-body pfs s-list card-box">              
                                <Tabs defaultActiveKey="1" onChange={(key) => this.setTab(key)} size='large'>
                                    <TabPane tab={<span>Patient &nbsp;&nbsp;</span>} key="1">                                       
                                        <Col span={24} className="stat-card">
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col span={24} className="stat-card">                                                  
                                                    {patientEdqaLink && patientEdqaLink.url.length > 0 && <DownloadOutlined className='bold-icon' onClick={() => this.downloadFile(patientEdqaLink.url)} title="Download underlying data" disabled={loading}/>}
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.noDateOfBirth.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CarryOutOutlined className="db-i"  />
                                                        <div className="custom-card">
                                                            <h3> No Date Of Birth &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.inconsistentArtStartDate.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ContactsOutlined className="db-i"/>
                                                        <div className="custom-card">
                                                            <h3> Inconsistent ART Start Date &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.noSex.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <PullRequestOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Sex &nbsp;</h3>
                                                        </div>
                                                    </Card> 
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.noPhoneNumber.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <PhoneOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Phone Number &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.noHospitalNumber.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ContainerOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Hospital Number &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.noAddress.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <BankOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Address &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.noStateOfResidence.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <AuditOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No State Of Residence &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{patientDqa.noLGA.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <EyeInvisibleOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No LGA &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </TabPane>
                                    <TabPane tab={<span> Drug Pickups &nbsp;&nbsp; </span>} key="2" >
                                        <Col span={24} className="stat-card">
                                            <Row className="sr row-30px-pad-10px-top">                                               
                                                <Col span={24} className="stat-card">
                                                    {phEdqaLink && phEdqaLink.url.length > 0 && <DownloadOutlined className='bold-icon' onClick={() => this.downloadFile(phEdqaLink.url)} title="Download underlying data" disabled={loading}/>}
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noARVRegimen.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ExperimentOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No ARV Regimen &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noCurrentRegimenLine.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <BarsOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>No Current Regimen Line</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.zeroDuration.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ExceptionOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>Zero Duration</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.below30Duration.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>Durations &gt; 0 &lt; 30</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.durationAbove180.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>Durations &gt; 180</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noTreatmentAgeCategory.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <svg className="bi bi-people db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.995-.944v-.002.002zM7.022 13h7.956a.274.274 0 00.014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 00.022.004zm7.973.056v-.002.002zM11 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zM6.936 9.28a5.88 5.88 0 00-1.23-.247A7.35 7.35 0 005 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 015 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                                                        </svg>
                                                        <div className="custom-card">
                                                            <h3>No Treatment Age Category</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.zeroDosage.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>Zero Dosage</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noFrequency.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <EyeInvisibleOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>No Frequency</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noARVQtyPrescribed.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>Zero Qty. Prescribed</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noARVQtyDispensed.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>Zero Qty. Dispensed</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noTreatmentType.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <MedicineBoxOutlined className="bi bi-people db-i" />
                                                        <div className="custom-card">
                                                            <h3>No Treatment Type</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noVisitType.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <SolutionOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>No Visit Type</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noPickUpReason.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ReconciliationOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>No PickUp Reason</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noModelOfCare.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <FileSyncOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>No Model of Care</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pharmacyDqa.noARVStrenght.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <TagsOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3>No ARV Strenght</h3>
                                                        </div>
                                                    </Card>
                                                    <div style={{ display: 'none' }}>
                                                        <iframe src={fileUrl} />
                                                    </div>
                                                </Col>

                                            </Row>
                                        </Col>
                                    </TabPane>
                                    <TabPane tab={<span> ART Commencement &nbsp;&nbsp;  </span>} key="3">
                                        <Col span={24} className="stat-card">
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col span={24} className="stat-card">
                                                    {artEdqaLink && artEdqaLink.url.length > 0 && <DownloadOutlined className='bold-icon' onClick={() => this.downloadFile(artEdqaLink.url)} title="Download underlying data" disabled={loading}/>}
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noClinicalStageAtStartOfART.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <UngroupOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No WHO Stage At Start Of ART &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noFirstRegimenLine.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <BarsOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No First Regimen Line &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noFirstArvRegimen.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ExperimentOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No First Regimen &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noFunctionalStatus.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <SwitcherOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Functional Status &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noArtStartDate.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ScheduleOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No ArtStart Date &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noWhoStage.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <FileUnknownOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No WHO Stage &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noHeight.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Height &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noWeight.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Weight &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{artCommencementDqa.noMuac.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <TagOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No MUAC &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </TabPane>
                                    <TabPane tab={<span>HIV Enrolment &nbsp;&nbsp; </span>} key="4">
                                        <Col span={24} className="stat-card">
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col span={24} className="stat-card">
                                                    {hivEnrlmtEdqaLink && hivEnrlmtEdqaLink.url.length > 0 && <DownloadOutlined className='bold-icon' onClick={() => this.downloadFile(hivEnrlmtEdqaLink.url)} title="Download underlying data" disabled={loading}/>}
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{hivEnrollmentDqa.noDateEnrolledInCare.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalendarOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Date Enrolled in Care &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{hivEnrollmentDqa.noDateConfirmedHIVPositive.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CarryOutOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Date Confirmed HIV Positive &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{hivEnrollmentDqa.noModeOfHIVTest.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CodeOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Mode Of HIV Test &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{hivEnrollmentDqa.noCareEntryPoint.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <SwitcherOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Care Entry Point &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{hivEnrollmentDqa.noArtStartDate.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ScheduleOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No ArtStart Date &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{hivEnrollmentDqa.noFacilityTransferredInFrom.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <FileUnknownOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Facility Transferred in From &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{hivEnrollmentDqa.noDateTransferredIn.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalendarOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Date Transferred in &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </TabPane>
                                    <TabPane tab={<span>Care card &nbsp;&nbsp; </span>} key="5">
                                        <Col span={24} className="stat-card">
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col span={24} className="stat-card">
                                                    {ccardEdqaLink && ccardEdqaLink.url.length > 0 && <DownloadOutlined className='bold-icon' onClick={() => this.downloadFile(ccardEdqaLink.url)} title="Download underlying data" disabled={loading}/>}
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{carecardDqa.noNextAppointmentDate.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalendarOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Next Appointment Date &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{carecardDqa.noFunctionalStatus.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <BarsOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Functional Status &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{carecardDqa.noWhoStage.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ExceptionOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No WHO Stage &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{carecardDqa.noHeight.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <SwitcherOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Height &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{carecardDqa.noWeight.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalculatorOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Weight &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{carecardDqa.noDiastolic.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <FileUnknownOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Diastolic &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{carecardDqa.noSystolic.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <FileUnknownOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Systolic &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </TabPane>
                                    <TabPane tab={<span>Lab Order and Result &nbsp;&nbsp; </span>} key="6">
                                        <Col span={24} className="stat-card">
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col span={24} className="stat-card">
                                                    {labEdqaLink && labEdqaLink.url.length > 0 && <DownloadOutlined className='bold-icon' onClick={() => this.downloadFile(labEdqaLink.url)} title="Download underlying data" disabled={loading}/>}
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{labDqa.noSampleCollectionDate.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <CalendarOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Sample Collection Date &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{labDqa.noSampleType.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <BarsOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Sample Type &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{labDqa.noIndication.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ExperimentOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Indication for Viral Load &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{labDqa.noDateOrdered.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <SwitcherOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Date Ordered &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{labDqa.withoutResult.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ExceptionOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No Result &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>                                                
                                            </Row>
                                        </Col>
                                    </TabPane>
                                    <TabPane tab={<span>PBS &nbsp;&nbsp; </span>} key="7">
                                        <Col span={24} className="stat-card">
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col span={24} className="stat-card">
                                                    {pbsDqaEdqaLink && pbsDqaEdqaLink.url.length > 0 && <DownloadOutlined className='bold-icon' onClick={() => this.downloadFile(pbsDqaEdqaLink.url)} title="Download underlying data" disabled={loading}/>}
                                                </Col>
                                            </Row>
                                            <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3">{pbsDqa.noPbs.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        <ProjectOutlined className="db-i" />
                                                        <div className="custom-card">
                                                            <h3> No PBS &nbsp;</h3>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </TabPane>
                                </Tabs>                               
                            </Card>                            
                        </Col>                       
                    </Row>
                    <br />
                    <br />
                </div>                            
            </div>
        ) 
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Edqa as any);

